import { useState } from "react";
import { eventDrag, eventDragLeave, eventDrop, eventPaste, seleccionarArchivo } from "../../utils/utils";

const VistaArrastre = () => {
    return(
        <section className="w-full h-full border-2 border-dashed"></section>
    )
}

const VistaDocumento = ({documentos, seleccionarDocumento, envioDocumento, esBloqueo}) => {
    
    const IconoExcel = ({file}) => {
        return(
            <svg width="45" height="45" viewBox="0 0 32 32" cursor={'pointer'} fill="none" xmlns="http://www.w3.org/2000/svg"
                onClick={(e) => {e.preventDefault(); file?.codigo ? window.open(file.url) : e.stopPropagation()}}
            >
                <rect x="8" y="2" width="24" height="28" rx="2" fill="#2FB776"/>
                <path d="M8 23H32V28C32 29.1046 31.1046 30 30 30H10C8.89543 30 8 29.1046 8 28V23Z" fill="url(#paint0_linear_87_7712)"/>
                <rect x="20" y="16" width="12" height="7" fill="#229C5B"/>
                <rect x="20" y="9" width="12" height="7" fill="#27AE68"/>
                <path d="M8 4C8 2.89543 8.89543 2 10 2H20V9H8V4Z" fill="#1D854F"/>
                <rect x="8" y="9" width="12" height="7" fill="#197B43"/>
                <rect x="8" y="16" width="12" height="7" fill="#1B5B38"/>
                <path d="M8 12C8 10.3431 9.34315 9 11 9H17C18.6569 9 20 10.3431 20 12V24C20 25.6569 18.6569 27 17 27H8V12Z" fill="#000000" fill-opacity="0.3"/>
                <rect y="7" width="18" height="18" rx="2" fill="url(#paint1_linear_87_7712)"/>
                <path d="M13 21L10.1821 15.9L12.8763 11H10.677L9.01375 14.1286L7.37801 11H5.10997L7.81787 15.9L5 21H7.19931L8.97251 17.6857L10.732 21H13Z" fill="white"/>
                <defs>
                <linearGradient id="paint0_linear_87_7712" x1="8" y1="26.5" x2="32" y2="26.5" gradientUnits="userSpaceOnUse">
                <stop stop-color="#163C27"/>
                <stop offset="1" stop-color="#2A6043"/>
                </linearGradient>
                <linearGradient id="paint1_linear_87_7712" x1="0" y1="16" x2="18" y2="16" gradientUnits="userSpaceOnUse">
                <stop stop-color="#185A30"/>
                <stop offset="1" stop-color="#176F3D"/>
                </linearGradient>
                </defs>
            </svg>
        )
    }
    
    const IconoWord = ({file}) => {
        return(
            <svg width="45" height="45" viewBox="0 0 32 32" cursor={'pointer'} fill="none" xmlns="http://www.w3.org/2000/svg"
                onClick={(e) => {e.preventDefault(); file?.codigo ? window.open(file.url) : e.stopPropagation()}}
            >
                <rect x="8" y="2" width="24" height="28" rx="2" fill="url(#paint0_linear_87_7724)"/>
                <path d="M8 23H32V28C32 29.1046 31.1046 30 30 30H10C8.89543 30 8 29.1046 8 28V23Z" fill="url(#paint1_linear_87_7724)"/>
                <rect x="8" y="16" width="24" height="7" fill="url(#paint2_linear_87_7724)"/>
                <rect x="8" y="9" width="24" height="7" fill="url(#paint3_linear_87_7724)"/>
                <path d="M8 12C8 10.3431 9.34315 9 11 9H17C18.6569 9 20 10.3431 20 12V24C20 25.6569 18.6569 27 17 27H8V12Z" fill="#000000" fill-opacity="0.3"/>
                <rect y="7" width="18" height="18" rx="2" fill="url(#paint4_linear_87_7724)"/>
                <path d="M15 11.0142H13.0523L11.5229 17.539L9.84967 11H8.20261L6.51634 17.539L5 11.0142H3L5.60131 21H7.3268L9 14.6879L10.6732 21H12.3987L15 11.0142Z" fill="white"/>
                <defs>
                <linearGradient id="paint0_linear_87_7724" x1="8" y1="6.66667" x2="32" y2="6.66667" gradientUnits="userSpaceOnUse">
                <stop stop-color="#2B78B1"/>
                <stop offset="1" stop-color="#338ACD"/>
                </linearGradient>
                <linearGradient id="paint1_linear_87_7724" x1="8" y1="27.375" x2="32" y2="27.375" gradientUnits="userSpaceOnUse">
                <stop stop-color="#1B366F"/>
                <stop offset="1" stop-color="#2657B0"/>
                </linearGradient>
                <linearGradient id="paint2_linear_87_7724" x1="18.5" y1="20" x2="32" y2="20" gradientUnits="userSpaceOnUse">
                <stop stop-color="#20478B"/>
                <stop offset="1" stop-color="#2D6FD1"/>
                </linearGradient>
                <linearGradient id="paint3_linear_87_7724" x1="18.5" y1="13" x2="32" y2="13" gradientUnits="userSpaceOnUse">
                <stop stop-color="#215295"/>
                <stop offset="1" stop-color="#2E84D3"/>
                </linearGradient>
                <linearGradient id="paint4_linear_87_7724" x1="3.31137e-08" y1="17" x2="19" y2="17" gradientUnits="userSpaceOnUse">
                <stop stop-color="#223E74"/>
                <stop offset="1" stop-color="#215091"/>
                </linearGradient>
                </defs>
            </svg>
        )
    }
    
    const IconoPpt = ({file}) => {
        return(
            <svg xmlns="http://www.w3.org/2000/svg" cursor={'pointer'} width="45" height="45" viewBox="0 0 110.031 107.5" id="powerpoint"
            onClick={(e) => {e.preventDefault(); file?.codigo ? window.open(file.url) : e.stopPropagation()}}
            >
                <path fill="#d24625" d="M57.893 0h7.087v11.25c13.363.075 26.738-.138 40.088.062 2.875-.275 5.125 1.962 4.838 4.837.212 23.35-.05 46.712.125 70.075-.125 2.525.25 5.325-1.2 7.562-1.825 1.325-4.2 1.15-6.338 1.25-12.5-.062-25-.037-37.513-.037v12.5h-7.774c-19.05-3.475-38.138-6.65-57.2-10-.013-29.162 0-58.325 0-87.475C19.292 6.688 38.58 3.288 57.893 0z"></path>
                <path fill="#fff" d="M64.98 15h41.25v76.25H64.98v-10h30v-5h-30V70h30v-5H64.993c-.013-2.45-.013-4.9-.024-7.35 4.95 1.537 10.587 1.5 15.012-1.476 4.788-2.837 7.288-8.25 7.7-13.65-5.487-.038-10.975-.025-16.45-.025-.012-5.438.062-10.875-.112-16.3-2.05.4-4.1.825-6.138 1.262V15z"></path>
                <path fill="#d24625" d="M73.743 23.587c8.688.4 15.987 7.712 16.45 16.375-5.488.063-10.975.038-16.463.038 0-5.475-.012-10.95.013-16.413z"></path>
                <path fill="#fff" d="M20.055 33.025c6.788.325 15.013-2.688 20.638 2.4 5.388 6.538 3.963 18.562-4.025 22.476-2.837 1.449-6.087 1.25-9.175 1.149-.013 4.888-.024 9.775-.013 14.663a1323.27 1323.27 0 0 0-7.438-.625c-.112-13.351-.136-26.713.013-40.063z"></path>
                <path fill="#d24625" d="M27.48 39.788c2.463-.113 5.513-.562 7.176 1.75 1.425 2.45 1.35 5.675.162 8.2-1.425 2.575-4.65 2.325-7.138 2.625-.263-4.188-.237-8.376-.2-12.575z"></path>
            </svg>
        )
    }
    
    const IconoPdf = ({file}) => {
        return(
            <svg xmlns="http://www.w3.org/2000/svg" cursor={'pointer'} height="40" id="2" width="40" viewBox="0 0 650 650"
                onClick={(e) => {e.preventDefault(); file?.codigo ? window.open(file.url) : e.stopPropagation()}}
            >
                <path fill="#d41111" d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"/>
            </svg>
        )
    }
    
    const IconoBlocNota = ({file}) => {
        return(
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 50 50"  cursor={'pointer'}
                onClick={(e) => {e.preventDefault(); file?.codigo ? window.open(file.url) : e.stopPropagation()}}
            >
                <path d="M 7 2 L 7 48 L 43 48 L 43 14.59375 L 42.71875 14.28125 L 30.71875 2.28125 L 30.40625 2 Z M 9 4 L 29 4 L 29 16 L 41 16 L 41 46 L 9 46 Z M 31 5.4375 L 39.5625 14 L 31 14 Z"></path>
            </svg>
        )
    }

    const iconosPorExtension = {
        csv: IconoExcel,
        xls: IconoExcel,
        xlsx: IconoExcel,
        doc: IconoWord,
        docx: IconoWord,
        ppt: IconoPpt,
        pptx: IconoPpt,
        pdf: IconoPdf,
        txt: IconoBlocNota,
    }

    const asignarIcono = (file) => {
        const extensionesDocumento = Object.keys(iconosPorExtension);
        file.extension = file.extension || extensionesDocumento.find(e => file.url.includes(e));
        const Icono = iconosPorExtension[file.extension];
        return Icono ? Icono({file:file}) : '';
    }
    
    return(
        Array.isArray(documentos) && documentos.length > 0 ?         
            (
                <section className="w-full h-full flex flex-col lg:gap-1">
                    <div
                        className="flex gap-3 w-[100%] overflow-x-auto containerScroll h-[70%] items-center"
                    >
                        {
                            documentos.map((doc, i) =>
                                (
                                    <div className="flex items-center" key={i + doc.codigo}>
                                        {asignarIcono(doc)}
                                        <i
                                            className={`fa fa-times text-red-600 absolute top-0 -right-2 cursor-pointer ${esBloqueo ? ' hidden ' : ''}`}
                                            onClick={() => envioDocumento({tipo: 'Remover', carga: doc })}
                                        ></i>
                                    </div>
                                )
                            )
                        }
                    </div>
                    <section key={'_divIconos'} className="h-[30%] w-full flex items-center justify-center">
                        <label htmlFor="file-documentoCarrusel" key={'_labelIcono'} className="lg:flex" data-tip={'addImg'} data-for={'addImg'}>
                            <img
                                src="https://cdn-icons-png.flaticon.com/512/2716/2716054.png"
                                className="w-[30px] h-[30px] cursor-pointer"
                                alt=""
                            >
                            </img>
                            <input
                                key={'_inputDocumentoCarrusel'}
                                type="file"  accept='.pdf,.doc,.docx,.txt,.ppt,.pptx,.xls,.xlsx'
                                name="file-documentoCarrusel" id="file-documentoCarrusel"
                                className="inputfile inputfile-1" 
                                onChange={(e)=>{seleccionarArchivo(e, envioDocumento,'doc', esBloqueo)}} 
                            />
                        </label>
                        {/* <Tooltip id={'addImg'}>Agregar una nueva imagen</Tooltip> */}
                    </section>
                </section>
            )
        : 
        (
            esBloqueo ? 
                <></>
            : 
                <section className="border-[1px] border-zinc-600 border-dashed w-full h-full flex flex-col justify-center items-center bg-zinc-800">
                    <span className="text-xl lg:text-xs text-center">Arrastrar hasta aquí o pegar su documento</span>
                    <label htmlFor="file-documento" key={'_labelIcono'} className="lg:flex" data-tip={'addImg'} data-for={'addImg'}>
                        <img
                            src="https://cdn-icons-png.flaticon.com/512/2716/2716054.png"
                            className="w-[50px] h-[50px] cursor-pointer"
                            alt=""
                        >
                        </img>
                        <input
                            key={'_inputDocumento'}
                            type="file"  accept='.pdf,.doc,.docx,.txt,.ppt,.pptx,.xls,.xlsx'
                            name="file-documento" id="file-documento"
                            className="inputfile inputfile-1" 
                            onChange={(e)=>{seleccionarArchivo(e, envioDocumento,'doc', esBloqueo)}} 
                        />
                    </label>
                </section>
        )       
    )
}

export const ContenedorDocumento = ({ archivo=[], envioDocumento, esBloqueo, className}) => {

    const [ arrastrarDocumento, setArrastrarDocumento ] = useState(false);
    
    return(
        <section 
            className={`${className ? className : ''} h-full w-full rounded border border-zinc-600 bg-zinc-900 p-5 flex items-center`}
            key={'_divContenedorPrincipal'}
            onPaste={(e) => eventPaste(e, envioDocumento, 'doc', esBloqueo)}
            onDragOver={(e) => eventDrag(e, setArrastrarDocumento, esBloqueo)}
            onDrop={(e) => eventDrop(e, envioDocumento, 'doc', setArrastrarDocumento, esBloqueo)}
            onDragLeave={() => eventDragLeave(setArrastrarDocumento)}
        >
            {
                arrastrarDocumento ? 
                    VistaArrastre()
                :
                    VistaDocumento({documentos: archivo, seleccionarArchivo: seleccionarArchivo, envioDocumento: envioDocumento , esBloqueo: esBloqueo})
            }

        </section>
    )
}